export default __webpack_public_path__ + "static/media/dong-gia-1k-ve-khi-mua-ve-qua-tix-16011908558560.26528b82.jpg";